// ===================================================================
// categoryLabels.ts — i18n display labels for vocabulary category keys
// ===================================================================
// Category keys (e.g. 'Famille', 'Verbes') are used as data lookup keys
// throughout the app — CategoryDictionary, localStorage, progress tracking,
// KAMA_NON_VOCAB_CATEGORIES... They must never be renamed. This module only
// maps the raw key to a translated *display* label; callers keep using the
// raw key for everything else (data lookup, storage, onClick handlers...).
import { TFunction } from 'i18next';

const CATEGORY_LABEL_KEYS: Record<string, string> = {
  'Alphabet copte': 'categorySelection.categories.copticAlphabet',
  'Alphabet yoruba': 'categorySelection.categories.yorubaAlphabet',
  'Salutations et expressions courantes': 'categorySelection.categories.greetings',
  'Lire les hiéroglyphes': 'categorySelection.categories.readingHieroglyphs',
  'Phrase': 'categorySelection.categories.phrase',
  'Phrase — le nom': 'categorySelection.categories.phraseNoun',
  'Phrase — pronoms': 'categorySelection.categories.phrasePronouns',
  'Lecture analytique': 'categorySelection.categories.analyticalReading',
  'Lecture analytique — déterminatifs': 'categorySelection.categories.analyticalReadingDeterminatives',
  'Lecture analytique — Kemet': 'categorySelection.categories.analyticalReadingKemet',
  'Lecture analytique — histoire': 'categorySelection.categories.analyticalReadingHistory',
  'Famille': 'categorySelection.categories.family',
  'Couleurs': 'categorySelection.categories.colors',
  'Verbes': 'categorySelection.categories.verbs',
  'Nombres': 'categorySelection.categories.numbers',
  'Animaux': 'categorySelection.categories.animals',
  'Nourriture': 'categorySelection.categories.food',
  'Corps': 'categorySelection.categories.body',
  'Temps': 'categorySelection.categories.time',
  'Objets du quotidien': 'categorySelection.categories.everydayObjects',
  'Objets sacrés et du quotidien': 'categorySelection.categories.sacredEverydayObjects',
  'Divinités': 'categorySelection.categories.deities',
  'Villes': 'categorySelection.categories.cities',
  'Pharaons': 'categorySelection.categories.pharaohs',
  'Plantes': 'categorySelection.categories.plants',
  'Sur les murs des temples': 'categorySelection.categories.templeWalls',
};

// Categories absent from the map above (shouldn't normally happen) fall
// back to displaying the raw key as-is, i.e. today's behavior.
export const displayCategoryLabel = (cat: string, t: TFunction): string => {
  const key = CATEGORY_LABEL_KEYS[cat];
  return key ? t(key) : cat;
};
